import styled from 'styled-components';
import {StyledBaseProps} from "@betrue/shared/interfaces";
import {Grid, IconButton, TextField, Typography} from "@mui/material";
import * as React from "react";
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import {useEffect, useState} from "react";

export interface EditableFieldViewProps extends StyledBaseProps {
  isEditEnabled: boolean
  onSubmit: (v: string | number) => void
  onCancel: () => void
  value: string | number
  label: string
}

export const EditableFieldView = styled((props: EditableFieldViewProps) => {

  const [currentValue, setCurrentValue] = useState<number | string>(undefined)

  useEffect(() => {
  }, [props.value])

  return (<span className={props.className}>

      {props.isEditEnabled ? (
          <Grid container alignContent={"center"} direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={8} >
              <TextField style={{fontSize:'24px'}} label={props.label ? props.label : 'input label'} variant="standard" onChange={(e) => setCurrentValue(e.target.value)}
                         value={currentValue}/>
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => props.onSubmit(currentValue)} aria-label="delete">
                <CheckIcon  fontSize="small"/>
              </IconButton>
            </Grid>
            <Grid item xs={2}>
              <IconButton aria-label="delete" onClick={() => {
                setCurrentValue(undefined)
                props.onCancel()
              }}>
                <ClearIcon  fontSize="small"/>
              </IconButton>
            </Grid>
          </Grid>) :
        (<Grid container alignContent={"center"} direction="row" justifyContent="center" alignItems="center"
        >
          <Grid item xs={8} >
            <h4>{props.value}</h4>
          </Grid>
          <Grid item xs={4}>
            <IconButton onClick={() => props.onSubmit(props.value)}  aria-label="delete">
              <EditIcon fontSize="small"/>
            </IconButton>
          </Grid>
        </Grid>)}
</span>)
})`
  vertical-align: center;
  max-width: 200px;
  position: relative;
  text-align: center;
  & h4 {
    color: ${props => props.theme.colors.secondary};
    font-size: 24px;
    font-weight: normal;
    text-align: center;
    margin: 10px;
  }
`
